<template>
    <div>
        <div class="container">
            <div class="dados-conta bg-white mt-3 ">
                <form ref="form-nova-senha" class="form-group">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-custom">
                                <label for="senhaAtual" class="bmd-label-floating">Senha Atual</label>
                                <input type="password" class="form-control" name="senhaAtual" v-model="model.senhaAtual" placeholder="Informe a Senha Atual" required>
                            </div>
                            <div class="form-group">
                                <label for="senha">Nova Senha</label>
                                <input type="password" class="form-control" name="senha" v-model="model.senha" placeholder="Informe a Nova Senha" required>
                            </div>
                            <div class="form-group">
                                <label for="confirmacao">Confirmar Nova Senha</label>
                                <input type="password" class="form-control" name="confirmacao" v-model="model.confirmacao" placeholder="Informe a Confirmação da Senha" required >
                            </div>
                        </div>
                        <div class="col-md-6 mt-4">
                            <div class="alert alert-secondary text-center">
                                <strong>Dica de segurança</strong><br />
                                <span class="small">Crie uma senha com no mínimo 6 caracteres. <!--Você <strong>deve</strong> usar letras, maiúsculas, números ou caracteres especiais (como $, #, @).--></span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 mt-2 ">
                                <div class="alert alert-warning" role="alert">
                                    Ao confirmar a alteração da senha, a mesma será refletida para todos os sistemas do CNA, como: CNA Net, Shopping CNA e Meu CNA.
                                </div>
                                <div class="logos-ajuste-senha">
                                    <img src="../../assets/images/CNANET.svg" height="59" />
                                    <img src="../../assets/images/logo_shoppingcolor.png" height="80" class="mx-4" />
                                    <img src="../../assets/images/logo_meu_CNA.png" height="59" />
                                </div>
                            </div>
                            <!--<img src=""/>
                            <img src=""/>-->

                        </div>
                        <div class="row col-md-12 mt-3">
                            <div class="col-6 ">
                                <button type="button" class="btn btn-danger border-primary rounded-pill previous-button px-4" @click="onBack()">Voltar</button>
                            </div>
                            <div class="col-6 text-right">
                                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="alteraSenha()">Continuar</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>



<script>
    import base from '@/common/base.js'
    import Global from '@/common/global'
    import Cookie from '@/common/cookie'
    import { Api } from '@/common/api'

    export default {
        name: 'nova-senha',
        mixins: [base],
        data: () => ({
            id: null,
            model: {},
            result: {}

        }),
        methods: {
            alteraSenha() {
                if (this.formValidate() == false)
                    return;

                this.showLoading();
                this.model.pessoaCNAId = this.id;
                this.model.username = Cookie.get("USERNAME");
                this.model.trocaSenhaPeloPerfil = true;

                new Api('pessoacnaacesso/NovaSenhaUsuario').get(this.model).then(result => {
                    this.result = result.data;
                    this.hideLoading();
                    this.$eventHub.$emit('show-notification', {
                        type: 'success',
                        title: 'Senha Alterada',
                        text: 'Senha Alterada com sucesso!'
                    });

                    this.$emit('on-saved')

                }, err => {
                    this.hideLoading();
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors.join(),
                        modal: true,
                        html: true,
                    });
                })
            },
            onBack: function () {
                this.$emit('on-back')
            },

            formValidate: function () {
                var $form = this.$refs["form-nova-senha"];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

        },

        mounted() {
            this.id = this.$attrs.id;
        }
    };
</script>
